import { memo, useCallback } from "react"
import { Handle, Position } from "@xyflow/react"
import { getTeamColor } from "./teams"
import EditableLabel from "../EditableLabel"
import { useNodeContext } from "../NodeContext"

const ExternalNode = memo(({ id, data, selected }) => {
  const teamColor = getTeamColor(data.team)
  const { onLabelChange } = useNodeContext()

  const handleLabelSave = useCallback((newLabel) => {
    onLabelChange(id, newLabel)
  }, [id, onLabelChange])

  return (
    <div className={`external-node ${selected ? "selected" : ""}`}>
      <Handle type="target" position={Position.Left} id="target-left" />
      <Handle type="target" position={Position.Top} id="target-top" />

      <div className="node-content">
        <EditableLabel
          value={data.label}
          onSave={handleLabelSave}
          className="node-label font-medium text-sm"
        />
        {data.tags && data.tags.length > 0 && (
          <div className="node-tags">
            {data.tags.map((tag) => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        )}
      </div>

      {teamColor && (
        <div className="team-badge" style={{ backgroundColor: teamColor }} />
      )}

      <Handle type="source" position={Position.Right} id="source-right" />
      <Handle type="source" position={Position.Bottom} id="source-bottom" />
    </div>
  )
})

ExternalNode.displayName = "ExternalNode"

export default ExternalNode
